import { useState } from 'react';

import { Link } from 'react-router-dom';

import { Card, Table, Input, Row, Col, Button } from 'antd';

import {
  DeleteFilled,
  EditFilled,
  PlusCircleOutlined,
} from '@ant-design/icons';

import { subscribeApiEndpoints } from '@/api/endpoints';
import { handleDeleteApi } from '@/api/crud';

import { useFetch } from '@/hooks';

import { globalSearch } from '@/utils/search/Search';
import GlobalModal from '@/utils/modal/Modal';
import { enablePaginationOrNot } from '@/utils/common';
import { CiSearch } from 'react-icons/ci';

const Subscription = () => {
  const { data, isSuccess, isLoading, refresh } = useFetch(
    subscribeApiEndpoints.list,
  );
  const [searchQuery, setSearchQuery] = useState('');
  const [open, setOpen] = useState(false);
  const [referenceId, setReferenceId] = useState(null);
  const [loading, setLoading] = useState(false);

  const Column = [
    {
      title: 'S.N',
      dataIndex: 'index',
      align: 'center',
      key: 'index',
    },
    {
      title: 'Subscriber Id',
      dataIndex: 'subscriptionId',
      align: 'center',
      key: 'subscriptionId',
    },

    {
      title: 'No of Company',
      dataIndex: 'noOfCompany',
      align: 'center',
      key: 'noOfCompany',
    },
    {
      title: 'No of Branch',
      dataIndex: 'noOfBranch',
      align: 'center',
      key: 'noOfBranch',
    },

    {
      title: 'No of User',
      dataIndex: 'noOfUser',
      align: 'center',
      key: 'noOfUser',
    },
    {
      title: 'Version',
      dataIndex: 'version',
      align: 'center',
      key: 'version',
    },
    {
      title: 'Start Date',
      dataIndex: 'startDate',
      align: 'center',
      key: 'startDate',
    },
    {
      title: 'Expiry Date',
      dataIndex: 'expiryDate',
      align: 'center',
      key: 'expiryDate',
    },
    {
      title: 'Action',
      align: 'center',
      render: (item) => (
        <>
          <div className="ant-action tw-flex tw-gap-4 tw-justify-center">
            <div className="">
              <Link
                size="medium"
                className="edit"
                to={`/subscription/${item.key}/edit/`}
              >
                <EditFilled className="" />
              </Link>
            </div>
            <div className="ant-button-delete">
              <Link
                size="medium"
                className="text-danger"
                onClick={() => openModal(item.key)}
              >
                <DeleteFilled />
              </Link>{' '}
            </div>
          </div>
        </>
      ),
    },
  ];
  const openModal = (id) => {
    setReferenceId(id);
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
    setReferenceId(null);
  };
  const handleOk = () => {
    setOpen(false);
    handleDeleteApi(
      referenceId,
      subscribeApiEndpoints.delete,
      setLoading,
      refresh,
    );
  };

  return (
    <>
      <GlobalModal
        isVisible={open}
        onConfirm={handleOk}
        onClose={closeModal}
        type="delete"
      />

      <Card>
        <Row className="mb-4">
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <div className="flex justify-between">
              <Link to="/subscription/create/">
                <Button
                  className="header-add centered"
                  size="medium"
                  type="primary"
                >
                  <PlusCircleOutlined />
                  Create
                </Button>
              </Link>
              <div className="flex flex-col items-center justify-center gap-[10px]">
                <Input
                  className="header-search"
                  name="query"
                  placeholder="Search Subscriber..."
                  prefix={<CiSearch />}
                  value={searchQuery}
                  onChange={(event) => setSearchQuery(event.target.value)}
                />
              </div>
            </div>
          </Col>
        </Row>

        <Table
          columns={Column}
          scroll={{ x: true }}
          dataSource={
            isSuccess
              ? globalSearch(data, searchQuery).map((item, index) => {
                  return {
                    key: item.referenceId,
                    index: index + 1,
                    subscriptionId: item.subscriptionId,
                    name: item.username,
                    noOfCompany: item.noOfCompany,
                    noOfUser: item.noOfUser,
                    noOfBranch: item.noOfBranch,
                    version: item.version,
                    startDate: item.startDate,
                    expiryDate: item.expiryDate,
                  };
                })
              : []
          }
          loading={isLoading || loading}
          bordered
          pagination={!isLoading ? enablePaginationOrNot(data) : false}
        />
      </Card>
    </>
  );
};

export default Subscription;
